import { useEffect, useState } from "react";

const initialState = {
  data: null,
  loading: true,
  error: null,
  source: "loading",
  usedFallback: false,
};

function useContentResource(loader, dependencies = []) {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    async function run() {
      setState((current) => ({
        ...current,
        loading: true,
        error: null,
      }));

      try {
        const result = await loader({ signal: controller.signal });

        if (!isMounted) {
          return;
        }

        setState({
          data: result.data,
          loading: false,
          error: result.error,
          source: result.source,
          usedFallback: result.usedFallback,
        });
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setState({
          data: null,
          loading: false,
          error,
          source: "error",
          usedFallback: false,
        });
      }
    }

    run();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // `loader` is intentionally managed by the caller via dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return state;
}

export default useContentResource;
